export default "__VITE_ASSET__mbMQE739__"